/**
 * The new route document — what a setter's map tap writes
 * (`useMainApp.handleMapClickOrReposition`, docs/spec/11-map-routes.md). Pure, so the
 * E2E seed (tests/e2e/seed/) builds its fixture routes through the same
 * function instead of a second copy of the shape.
 *
 * No point value is stored on the route: every consumer derives it from
 * `difficulty` against the gym's live config, so a regrade or an admin
 * reweight can never leave a stale number behind. `ascentCount`,
 * `repeatCount` and `gradeOpinion` are server-maintained (triggers).
 */
import { DISCIPLINES } from "@sendly/shared";

/**
 * @param {object} p
 * @param {number} p.x, p.y          position on the map, in the map image's pixel
 *                                   coordinates (`settings.maps[i].width` × `height`)
 * @param {string} p.mapId
 * @param {string} [p.name]
 * @param {string|null} [p.difficulty]
 * @param {string|null} [p.holdColor]
 * @param {string} [p.discipline]    default boulder
 * @param {string} p.setterUid       the writer (also `lastModifiedBy`)
 * @param {string} [p.setterName]
 * @param {string} p.createdAt       the gym's day, "YYYY-MM-DD" (`todayStr`)
 */
export function buildNewRouteDoc({ x, y, mapId, name, difficulty, holdColor, discipline, setterUid, setterName, createdAt }) {
  return {
    x, y, mapId,
    name,
    difficulty: difficulty || null,
    holdColor: holdColor || null,
    discipline: discipline || DISCIPLINES.BOULDER,
    setter: setterUid,
    setterName: setterName || "",
    createdAt,
    active: true,
    lastModifiedBy: setterUid,
  };
}
